// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { AdminMenuItems, SuperAdminMenuItems } from './MenuItems';
import { useLocation } from 'react-router';
import { Box, List } from '@mui/material';
import NavItem from './NavItem';
import NavCollapse from './NavCollapse';
import NavGroup from './NavGroup/NavGroup';

import { RootState, useAppDispatch, useAppSelector } from '@shared/store';
import { actions } from '@shared/store/ducks';
import { useUserMeControllerUserMeQuery } from '@shared/services/apiService';

const SidebarItems = () => {
  const { pathname } = useLocation();
  const pathDirect = pathname;
  const pathWithoutLastPart = pathname.slice(0, pathname.lastIndexOf('/'));
  const customizer = useAppSelector((state: RootState) => state.customizer);
  const hideMenu: any = customizer.isCollapse && !customizer.isSidebarHover;

  const dispatch = useAppDispatch();

  const isSuperAdminPage = pathWithoutLastPart.includes('super-admin');
  const { data: me } = useUserMeControllerUserMeQuery(undefined, { skip: isSuperAdminPage });
  const MenuItems = (isSuperAdminPage ? SuperAdminMenuItems : AdminMenuItems).filter(
    (item: { requiredPrivileges?: string[] }) =>
      !item.requiredPrivileges ||
      item.requiredPrivileges.some((privilege) =>
        (me?.privileges as string[] | undefined)?.includes(privilege),
      ),
  );

  return (
    <Box sx={{ px: 3 }}>
      <List sx={{ pt: 0 }} className="sidebarNav">
        {MenuItems.map((item) => {
          // {/********SubHeader**********/}
          if (item.subheader) {
            return <NavGroup item={item} hideMenu={hideMenu} key={item.subheader} />;

            // {/********If Sub Menu**********/}
            /* eslint no-else-return: "off" */
          } else if (item.children) {
            return (
              <NavCollapse
                menu={item}
                pathDirect={pathDirect}
                hideMenu={hideMenu}
                pathWithoutLastPart={pathWithoutLastPart}
                level={1}
                key={item.id}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(actions.customizer.toggleMobileSidebar());
                }}
              />
            );

            // {/********If Sub No Menu**********/}
          } else {
            return (
              <NavItem
                item={item}
                key={item.id}
                pathDirect={pathDirect}
                hideMenu={hideMenu}
                onClick={() => dispatch(actions.customizer.toggleMobileSidebar())}
              />
            );
          }
        })}
      </List>
    </Box>
  );
};
export default SidebarItems;
